import { useQuery } from '@tanstack/react-query';
import { findAddresses } from '../services/addressLookup';
import { addressLookupKeys } from '../services/queryKeys';

export interface UseAddressFindParams {
    text: string;
    container?: string;
    enabled: boolean;
}

export const useAddressFind = ({ text, container, enabled }: UseAddressFindParams) =>
    useQuery({
        queryKey: addressLookupKeys.find(text, container),
        queryFn: ({ signal }) => findAddresses({ text, container }, signal),
        enabled,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        // A 502 means the upstream already ran and will fail the same way; an errored Find is
        // stale at once, so an ambient refetch would re-bill it with no user action behind it.
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
